// extracted by mini-css-extract-plugin
module.exports = {"left-container":"BigQueryEditor-module__left-container__2zZB5"};